import { gql } from "graphql-request";

export const projectBySlugQuery = gql`
query projectById($slug: String!){
  allSingleProject(where: {slug: {current: {eq: $slug}}}) {
    slug {current},
    project_title,
    project_summary,
     project_date,
      project_hero_image {image{asset{url}, alt_text}},
      project_image_header {image{image{asset{url},alt_text}}, color},
      project_image_footer {image{image{asset{url}, alt_text}}, color},
      project_content_images {
        color,
        project_image_1 {image{asset{url}, alt_text}},
        project_image_2 {image{asset{url}, alt_text}},
        project_image_3 {image{asset{url}, alt_text}},
        project_image_4 {image{asset{url}, alt_text}},
        project_image_5 {image{asset{url}, alt_text}},
        project_image_6 {image{asset{url}, alt_text}}
      }
  }
}`